import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import SrMyCartListItem from './SrMyCartListItem';
import NormalSmallBtn from '../common/button/NormalSmallBtn';
import CheckBtn from '../common/button/CheckBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setCartCheckInfoAction, cart_check_info, setCartHistoryKeyAction } from '../../modules/su/userProdModule';
import {setUserCartProdsListAction, syncUserCartAction} from '../../modules/su/userCartModule'
import { remove, findIndex, forEach, find } from 'lodash';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import Modal from 'react-modal';
import {isMobileOnly} from 'react-device-detect';
import { useHistory } from 'react-router-dom';

const SrMyCartListBlock = styled.div``;

const SrMyCartListHeaderBlock = styled.div`
    ${isMobileOnly?`
    ''   
    `:`
    border-bottom: solid 2px #111111;
    `};
    height: 60px;
    padding: 17px 0px;
`;

const SrMyCartListHeaderCheckBlock = styled.div`
    float : left;
    margin-top: -4px;
`;
const SrMyCartListHeaderSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 26px;   
    `:`
    font-size: 16px;
    `};
    float : left;
    margin-left : 10px;
    
    font-weight: normal;
    text-align: left;
    color: #333333;
`;

const MyCartListHeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const SrMyCartList = ({ cartProdList, showItemCnt, removeBrand }) => {
    const dispatch = useDispatch();
    const [myCartList, setMyCartList] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [msg1, setMsg1] = useState("");
    const [msg2, setMsg2] = useState("");
    const [msg3, setMsg3] = useState("");
    const [kind, setKind] = useState(0);
    const history = useHistory();

    const { accessToken, esItems, prodCartSoldInfo, prodCartCheckInfo, cartProdListReducer, cartHistoryKey } = useSelector(
        ({ userReducer, userCartReducer, esItemsReducer, userProdReducer }) => ({
            accessToken: userReducer.accessToken,
            cartProdListReducer: userCartReducer.cartProdList,
            esItems: esItemsReducer.esItems,
            prodCartSoldInfo: userProdReducer.prodCartSoldInfo,
            prodCartCheckInfo: userProdReducer.prodCartCheckInfo,
            cartHistoryKey: userProdReducer.cartHistoryKey,
        })
    );

    useEffect(() => {
        setMyCartList(cartProdList);
    }, [cartProdList, showItemCnt]);


    useEffect(() => {
        if(history.location.key !== cartHistoryKey){
            
            //Object.assign(checkInfo, prodCartCheckInfo);

            setTimeout(() => {
                let checkInfo = [];
                cartProdList.map((item, idx) => {
                    if (idx < showItemCnt) {
                        forEach(item.list, (curobj, index) => {
                            if(getSoldOutInfo(curobj)=== false){
                                let info = {};
                                Object.assign(info, cart_check_info)
                                info.brnd_id = curobj.brnd_id;
                                info.prdct_id = curobj.prdct_id;
                                info.qty = curobj.qty;
                                info.es_opt_pirce = curobj.es_opt_pirce;
                                info.prdct_price = curobj.prdct_price;
                                if(curobj.prdct_price === curobj.sale_price) {
                                    info.prdct_price = curobj.es_opt_pirce;
                                }
                                info.opt_id = curobj.opt_id;
                                if(getSoldOutInfo(curobj) ) {
                                    info.isSoldOut = true;
                                } else {
                                    info.isSoldOut = false;
                                }
                                checkInfo.push(info);
                            }
                        });
                    }
                })

                dispatch(setCartCheckInfoAction(checkInfo));
                dispatch(setCartHistoryKeyAction(history.location.key));
            }, 500);
        } else {
            setTimeout(() => {
                let checkInfo = [];
                //Object.assign(checkInfo, prodCartCheckInfo);
                forEach(prodCartCheckInfo, (curobj, index) => {
                    let info = {};
                    Object.assign(info,curobj );
                    checkInfo.push(info);
                });
                dispatch(setCartCheckInfoAction(checkInfo));
            }, 500);
            
        }
        
    }, []);


    // 브랜드 삭제 
    const handleAllDeleteBtnClick = (value) => {

       // removeBrand(value);
    }

    const handleCheckDeleteBtnClick = (value) => {
        // 팝업 표시
        // % 브랜드 % 의 상품들을 모두 삭제하시겠습니까 ?
        if(prodCartCheckInfo !== null && prodCartCheckInfo.length > 0) {
            setKind(0);
            setMsg1("");
            setMsg2("선택된 상품들을 삭제하시겠습니까?");
            setMsg3("");
            setOpenModal(true);
        }
    }

    const handleSoldOutDeleteBtnClick = (value) => {
        // 팝업 표시
        // % 브랜드 % 의 상품들을 모두 삭제하시겠습니까 ?
        if(prodCartSoldInfo !== null && prodCartSoldInfo.length > 0 ) {
            setKind(1);
            setMsg1("");
            setMsg2("품절된 상품들을 삭제하시겠습니까?");
            setMsg3("");
            setOpenModal(true);
        }
    }

    const getSoldOutInfo = (item) => {
        if(accessToken !== null) {
            //console.log("item = " + JSON.stringify(item));
            if(item !== null && item.sell_status !== '020102') {
                return true;
            }
            else if(item !== null && item.opt_id > 0 && item.opt_status < 1){
                return true;
            }
        }

        if(prodCartSoldInfo !== null && prodCartSoldInfo.length > 0){
            let info = find(prodCartSoldInfo, (curitem) => {
                return curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id;
            });

            //console.log("info = " + JSON.stringify(info));
            if(info !== undefined && info !== null && info.sell_status !== undefined && info.sell_status !== null && info.sell_status !== '020102') {
                return true;
            }
            else if(info !== undefined && info !== null && info.opt_id !== undefined && info.opt_id !== null && info.opt_id > 0 && info.opt_status < 1){
                return true;
            }
        }

        return false;
    }

    const handleCheckClick = (value) => {

        if(myCartList === null || myCartList === undefined) {
            return;
        }

        if (value) {
            let checkInfo = [];
            //Object.assign(checkInfo, prodCartCheckInfo);

            myCartList.map((item, idx) => {
                if (idx < showItemCnt) {
                    forEach(item.list, (curobj, index) => {
                        if(getSoldOutInfo(curobj)=== false){
                            let info = {};
                            Object.assign(info, cart_check_info)
                            info.brnd_id = curobj.brnd_id;
                            info.prdct_id = curobj.prdct_id;
                            info.qty = curobj.qty;
                            info.es_opt_pirce = curobj.es_opt_pirce;
                            info.prdct_price = curobj.prdct_price;
                            if(curobj.prdct_price === curobj.sale_price) {
                                info.prdct_price = curobj.es_opt_pirce;
                            }
                            info.opt_id = curobj.opt_id;
                            if(getSoldOutInfo(curobj) ) {
                                info.isSoldOut = true;
                            } else {
                                info.isSoldOut = false;
                            }
                            checkInfo.push(info);
                        }
                    });
                }
            })

            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo = " + JSON.stringify(checkInfo))
        } else {
            let checkInfo = [];
            
            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo del = " + JSON.stringify(checkInfo))
        }
    }

    // 체크 상태 확인
    const getCheckStatus = () => {
        let ret = true;
        let countSoldOut = 0;

        if(myCartList === null || myCartList === undefined) {
            return false;
        }

        forEach(myCartList, (curItem, index) => {
            var curList = curItem.list;
            forEach(curList, (curobj, index) => {
                if(getSoldOutInfo(curobj)=== false){
                    let idx = findIndex(prodCartCheckInfo, (curitem) => {
                        return (curitem.prdct_id === curobj.prdct_id && curitem.opt_id === curobj.opt_id);
                    })

                    if(idx < 0) {
                        ret =  false;
                    }
                } else {
                    countSoldOut++;
                }
            })
        })

        if(countSoldOut === cartProdListReducer.length) {
            return false;
        }

        return ret;
    }

    const getPopup = () => {
        if (kind === 0) {
            return (<NormalPopup
                text={msg1}
                text2={msg2}
                text3={msg3}
                btn1="삭제" btn2="취소"
                onClick1={handleModalBtn1Click}
                onClick2={handleModalBtn2Click} />)
        } else if (kind === 1) {
            return (<NormalPopup
                text={msg1}
                text2={msg2}
                text3={msg3}
                btn1="삭제" btn2="취소"
                onClick1={handleModalBtn1SoldOutClick}
                onClick2={handleModalBtn2Click} />)
        } 

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    // 선택 삭제 처리
    const handleModalBtn1Click = () => {
        //removeBrand(brnd_id);
        if (accessToken !== null) {
            // 기존에 브랜드 아이디가 없는 항목은 삭제
            // 옵션 아이디가 unique 하므로 비교하여 삭제 / 옵션이 없는 경우를 위해 상품 아이디도 같이 비교
            
            forEach(prodCartCheckInfo, (curobj, index) => {
                remove(cartProdListReducer, (obj) => {
                    return (obj.prdct_id === curobj.prdct_id && obj.opt_id === curobj.opt_id);
                })
            });
            
            dispatch(syncUserCartAction(cartProdListReducer));
        } else {
            //let targeItem = curItem[value];
            forEach(prodCartCheckInfo, (curobj, index) => {
                remove(cartProdListReducer, (obj) => {
                    return (obj.prdct_id === curobj.prdct_id && obj.opt_id === curobj.opt_id);
                })
            });
            // console.log(JSON.stringify(targeItem))
            dispatch(setUserCartProdsListAction(cartProdListReducer));
        }

        let checkInfo = [];
        dispatch(setCartCheckInfoAction(checkInfo));

        setOpenModal(false);
    }

    // 품절 삭제 처리
    const handleModalBtn1SoldOutClick = () => {
        //removeBrand(brnd_id);
        if (accessToken !== null) {
            remove(cartProdListReducer, (obj) => {
                return (getSoldOutInfo(obj) === true);
            })
            
            dispatch(syncUserCartAction(cartProdListReducer));
        } else {
            remove(cartProdListReducer, (obj) => {
                return (getSoldOutInfo(obj) === true);
            })
            dispatch(setUserCartProdsListAction(cartProdListReducer));
        }

        let checkInfo = [];
        dispatch(setCartCheckInfoAction(checkInfo));

        setOpenModal(false);
    }

    // 닫기
    const handleModalBtn2Click = () => {
        //dispatch(reqEsItemListAction());
        setOpenModal(false);
    }

    const haveSoldItem = () => {
        let result = false;
        
        if(cartProdListReducer === null || cartProdListReducer.length < 1) {
            return false;
        }
        for(var i = 0 ; i < cartProdListReducer.length; i++) {
            var curobj = cartProdListReducer[i];
            if(getSoldOutInfo(curobj) === false){

            }
            else{
                return true;
            }
        }

        return false;
    }

    if (myCartList === null) {
        return <SrMyCartListBlock />
    }

    return (
        <SrMyCartListBlock>
            <SrMyCartListHeaderBlock>
                 <SrMyCartListHeaderCheckBlock>
                    <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/>
                </SrMyCartListHeaderCheckBlock>
                <SrMyCartListHeaderSpanBlock>모두선택</SrMyCartListHeaderSpanBlock>
         
            <NormalSmallBtn float="right" marginBottom="20px" marginTop="-10px"
                    display='inline-block'
                    bgColor='transparent'
                    textColor="#999" fontSize={isMobileOnly ? "12px":"14px"} fontWeight="300"
                    width='fit-content'
                    text="선택삭제" onClick={handleCheckDeleteBtnClick} />
                    
            {haveSoldItem() ? 
            <NormalSmallBtn float="right" marginBottom="20px" marginTop="-10px"
            display='inline-block'
            bgColor='transparent'
            width='fit-content'
            marginRight={isMobileOnly ? "20px":"40px"}
            textColor="#999" fontSize={isMobileOnly ? "12px":"14px"} fontWeight="300"
            text="품절 상품 삭제" onClick={handleSoldOutDeleteBtnClick}
             /> : ''
            }
            </SrMyCartListHeaderBlock>
            {isMobileOnly&&<MyCartListHeaderGrayLine/>}
            {
                myCartList.map((item, idx) => {
                    if (idx < showItemCnt) {
                        return <SrMyCartListItem key={idx} cartItem={item.list}
                            brnd_id={item.brnd_id} removeBrand={handleAllDeleteBtnClick} />;
                    } else {
                        return null;
                    }
                })
            }
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>
        </SrMyCartListBlock>
    );
};

export default SrMyCartList;